module.exports = __webpack_public_path__ + "static/media/teacher-university-plan.18f1aa8a.png";